var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBellDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.045,
    height: 23.998,
    viewBox: "0 0 19.045 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1682.41,65.294h-7.255a.881.881,0,0,1-.71-1.4c4.387-6,.562-15.936,9.4-15.936,8.89,0,4.027,9.459,9.272,15.908a.88.88,0,0,1-.69,1.431H1682.41Z",
    transform: "translate(-1674.273 -47.955)",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.772,67.374a.454.454,0,0,1,.443.537,2.972,2.972,0,0,1-5.846,0,.454.454,0,0,1,.442-.537Z",
    transform: "translate(-1673.77 -46.347)",
    fill: "#7b7b7b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellDark);
export default __webpack_public_path__ + "static/media/notificationBellDark.336fccaf597c06c4fa0184d1b5f49da8.svg";
export { ForwardRef as ReactComponent };